import { CapoPlugin } from "/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];